import __poppyHandler from "./poppyHandler";

let __errorHandler = function(error) {

    let error_message = 'Hata oluştu, lütfen daha sonra tekrar deneyin.';
  
    if (error && error.response) {
      
      if (error.response.data) {
  
        if (error.response.data.messages) {
          error_message = error.response.data.messages[0];
        } else if (error.response.data.errors) {
          let error_keys = Object.keys(error.response.data.errors);
          error_message = error.response.data.errors[error_keys[0]][0];
        } else if (error.response.data.message) {
          error_message = error.response.data.message;
        } 
      }
        
    }
  
    __poppyHandler.error(error_message);
  }

  export default __errorHandler;